module.exports = function getDateString() {
	const today = new Date();
	const monthNames = [
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July',
		'August',
		'September',
		'October',
		'November',
		'December'
	];
	return `${today.getFullYear().toString()  } ${  monthNames[today.getMonth()]}`;
};



// WEBPACK FOOTER //
// ./src/utils/getDateString.js